import * as React from 'react';
import dayjs from 'dayjs';
import { DemoContainer } from '@mui/x-date-pickers/internals/demo';
import { LocalizationProvider } from '@mui/x-date-pickers/LocalizationProvider';
import { AdapterDayjs } from '@mui/x-date-pickers/AdapterDayjs';
import { DatePicker } from '@mui/x-date-pickers/DatePicker';

export default function MuiDatePicker({
  wrapperClasses,
  label,
  value,
  onChange,
  fullWidth,
  disabled,
  dataCy,
}) {
  return (
    <span className={wrapperClasses + ' shadow-sm'}>
      <LocalizationProvider dateAdapter={AdapterDayjs}>
        <DatePicker
          className={` ${fullWidth ? 'w-full' : ''}`}
          sx={{ minWidth: 150 }}
          readOnly={disabled}
          label={label}
          value={value ? dayjs(value) : null}
          onChange={onChange}
          format="DD-MM-YYYY"
          slotProps={{
            textField: {
              'data-cy': dataCy, // Ceci place data-cy sur le MuiTextField qui contient l'input
            },
          }}
        />
      </LocalizationProvider>
    </span>
  );
}
